/**
 * <notify-cta> — toggles a "Notify me" back-in-stock CTA when the selected
 * variant is sold out and back-in-stock is not disabled for the product.
 *
 * It listens for the theme's `variant:update` event (dispatched by the variant
 * picker after it re-fetches the section) and compares the selected variant id
 * against the server-provided list of notify-eligible variants.
 *
 * When active it sets [data-notify="true"] (CSS reveals the button and hides the
 * add-to-cart / checkout actions) and keeps the variant id on the "Notify me"
 * button (data-variant-id) so notify-me-dialog opens for the right variant.
 */
class NotifyCta extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.notifyVariants = new Set((this.dataset.notifyVariants || '').split(',').filter(Boolean));
    this.trigger = this.querySelector('.notify-cta__button');
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
    this.section?.addEventListener('variant:update', this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('variant:update', this.onVariantUpdate);
  }

  onVariantUpdate(event) {
    const detail = event.detail || {};
    const data = detail.data || {};

    // Ignore updates for a different product (combined listings).
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
      // A different product's notify set is unknown here — fall back to off.
      this.removeAttribute('data-notify');
      return;
    }
    if (data.productId && this.dataset.productId && data.productId !== this.dataset.productId) return;

    const variant = detail.resource;
    const id = variant && variant.id != null ? String(variant.id) : '';

    if (id && this.notifyVariants.has(id)) {
      this.setAttribute('data-notify', 'true');
      if (this.trigger) this.trigger.setAttribute('data-variant-id', id);
    } else {
      this.removeAttribute('data-notify');
    }
  }
}

if (!customElements.get('notify-cta')) {
  customElements.define('notify-cta', NotifyCta);
}
